<script setup lang="ts">
import { type FrontContent } from "@gasparigit/omnia-sdk";
import type { CreateLinkConfig } from "~/utils/types";

defineProps<{
  content: FrontContent;
  linkConfig?: CreateLinkConfig;
}>();
</script>

<template>
  <FrontContentCardsNotizia v-if="content.contentable_type === 'notizia'" v-bind="$props" :content="content" />
  <FrontContentCardsPratica v-else-if="content.contentable_type === 'pratica'" v-bind="$props" :content="content" />
  <FrontContentCardsModello v-else-if="content.contentable_type === 'modello'" v-bind="$props" :content="content" />
  <FrontContentCardsBaseContent v-else v-bind="$props" :content="content" />
</template>
